var render, staticRenderFns
import script from "./TabelaGenerica.vue?vue&type=script&lang=js&"
export * from "./TabelaGenerica.vue?vue&type=script&lang=js&"
import style0 from "./TabelaGenerica.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/generico/TabelaGenerica.vue
// module id = 20
// module chunks = 28